export enum TransferState {
  INCOMING,
  OUTGOING,
  CONNECTING,
  CONNECTED,
  IN_PROGRESS,
  COMPLETE,
  FAILED,
}
